<template>
  <v-form :lazy="true" @submit.prevent>
    <h2>Features</h2>
    <p class="help">Select all that apply:</p>

    <v-checkbox
      v-for="option in lenderFeatureOptions"
      :key="option.name"
      v-model="option.checked"
      :label="option.name"
      :hide-details="true"
      @change="updateProductFeatures(option.name)" />
  </v-form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SectionPractice',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    lenderFeatureOptions: [],
  }),

  computed: {
    ...mapState('questionnaireStore', {
      lenderFeatures: ({ questions }) => questions ? questions.lenderFeatures : [],
    }),
  },

  watch: {
    product () { this.updateInternalOptions() },
    lenderFeatures () { this.updateInternalOptions() },
  },

  created () { this.updateInternalOptions() },

  methods: {
    updateInternalOptions () {
      this.lenderFeatureOptions = this.lenderFeatures.map(type => ({
        name: type.name,
        title: type.title,
        checked: this.product && (this.product.lenderFeatures || []).includes(type.name),
      }))
    },

    updateProductFeatures (name) {
      const index = (this.product.lenderFeatures || []).findIndex(n => n === name)

      const newArr = (this.product.lenderFeatures || []).slice()
      if (index === -1) newArr.push(name)
      else newArr.splice(index, 1)

      this.$emit('change', { field: 'lenderFeatures', value: newArr })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
